export default {
  Carousel: "53aa8912dec7e10d38f59f36",
  Grid: "539adbd6dec7e10e686debee",
  Horizontal: "5406e65db0d04a09e042d5fc",
  List: "539ad60defb9600b94d7df2c",
  MiniCarousel: "539ad0ffdec7e10e686debd7",
  MicroStar: "5419b732fbfb950b10de65e5",
  MicroCombo: "5419b6ffb0d04a076446a9af",
  ProductMini: "54d39695764ea907c0f34825",
  Mini: "53aa8807dec7e10d38f59f32",
};
